/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { Spinner } from 'spin.js';
import { View } from 'backbone.marionette';
import Handlebars from 'handlebars';

import './Spinner.css';

const SpinnerView = View.extend({
  template: Handlebars.compile(''),

  className: 'spinner-view',

  defaultSpinnerOptions: {
    color: '#757575',
    width: 4,
    top: '50%',
  },

  onRender() {
    const inputOpts = this.options.spinner || {};
    const spinOpts = { ...this.defaultSpinnerOptions, ...inputOpts };
    this.spinner = new Spinner(spinOpts).spin(this.el);
  },

  stop() {
    this.spinner?.stop();
  },
});

export default SpinnerView;
